import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PurchaseOrder } from './orders.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  private readonly apiUrl = environment.apiUrl + '/concepts/orders';

  constructor(private http: HttpClient) {}

  getOrders(): Observable<PurchaseOrder[]> {
    return this.http.get<PurchaseOrder[]>(this.apiUrl);
  }

  getOrder(uid: string): Observable<PurchaseOrder> {
    return this.http.get<PurchaseOrder>(`${this.apiUrl}/${uid}`);
  }

  createOrder(order: PurchaseOrder): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(this.apiUrl, order);
  }

  duplicateOrder(uid: string): Observable<PurchaseOrder> {
    return this.http.post<PurchaseOrder>(`${this.apiUrl}/${uid}/duplicate`, {});
  }

  updateOrder(uid: string, order: Partial<PurchaseOrder>): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${uid}`, order);
  }

  deleteOrder(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  confirmReception(id: number, order: PurchaseOrder): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/confirm-reception`, order);
  }

  downloadPdf(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/pdf`, {
      responseType: 'blob',
    });
  }

  downloadExcel(id: number): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${id}/excel`, {
      responseType: 'blob',
    });
  }
}